/* eslint-disable */
import React from 'react';
import { MdLocationPin } from 'react-icons/md';
import {
  CCol,
  CRow,
  CFormInput,
  CCard,
  CCardBody,
  CFormLabel,
  CForm
} from '@coreui/react';
import Link from 'next/link';
import { useRouter } from 'next/router';

const List = ({ search, setSearch, division, language }) => {
  const router = useRouter();
  const id = router.asPath.split('/');

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <div className="content contents-list-pages-careers">
      <div className="col-our-office-location">
        <div className="container">
          <CRow>
            <CCol>
              <CForm className="form_career_search">
                <CFormInput
                  onChange={(e) => handleChange(e)}
                  className="form-input input_career_search"
                  type="text"
                  placeholder="Search By Position or Location"
                />
              </CForm>
            </CCol>
          </CRow>
          <CRow className="mt-4">
            {division?.careerList?.length === 0 ? (
              <>
                <center>
                  <h1>Not Found</h1>
                </center>
              </>
            ) : (
              <>
                {division?.careerList?.map((item) => (
                  <>
                    <h1
                      style={{
                        color: '#022e50',
                        fontWeight: '700',
                        fontSize: '20px',
                        letterSpacing: '0.42px',
                        marginBottom: '15px !important'
                      }}
                    >
                      {item.name}
                    </h1>
                    {item?.Careers?.map((secondItem, index) => (
                      <CCol
                        key={index}
                        md={6}
                        style={{ marginBottom: '-15px' }}
                      >
                        <Link
                          href={'/career/job/' + secondItem.id}
                          locale={language === 'ID' ? 'id' : 'en'}
                        >
                          <a
                            style={{
                              color: 'rgb(2, 46, 80)'
                            }}
                          >
                            <CCard key={index} style={{ cursor: 'pointer' }}>
                              <CCardBody>
                                <CRow>
                                  <CCol>
                                    <CFormLabel>
                                      {secondItem.position_name}
                                    </CFormLabel>
                                  </CCol>
                                </CRow>
                                <CRow>
                                  <CCol>
                                    <MdLocationPin size="14px" />{' '}
                                    <CFormLabel>
                                      {secondItem.location}
                                    </CFormLabel>
                                  </CCol>
                                </CRow>
                              </CCardBody>
                            </CCard>
                          </a>
                        </Link>
                      </CCol>
                    ))}
                  </>
                ))}
              </>
            )}
          </CRow>
        </div>
      </div>
    </div>
  );
};

export default List;
